export const isUpdatingProfile = () => {
  return localStorage.getItem('wtmdata') || null;
};
